import { render } from "./Administrations.vue?vue&type=template&id=1b35a614&scoped=true"
import script from "./Administrations.vue?vue&type=script&lang=js"
export * from "./Administrations.vue?vue&type=script&lang=js"

import "./Administrations.vue?vue&type=style&index=0&id=1b35a614&scoped=true&lang=css"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b35a614"]])

export default __exports__